import { config, handleResponse } from '../../_helpers';

export const containerYardService = {
    getAllContainerYards,
    getContainerYardById,
    createContainerYard,
    updateContainerYard,
    deleteContainerYard,
    activation,
    getActiveContainerYards
};

function getAllContainerYards(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/ContainerYards/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/ContainerYards/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function getContainerYardById(code) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ContainerYards/get/${code}`, requestOptions).then(handleResponse);
}
function createContainerYard(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ContainerYards`, requestOptions).then(handleResponse);
}
function updateContainerYard(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ContainerYards/update/${id}`, requestOptions).then(handleResponse);
}
function deleteContainerYard(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/ContainerYards/delete`, requestOptions).then(handleResponse);
}
function activation(code, isActive) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/ContainerYards/activate/${code}?isActive=${isActive}`, requestOptions).then(handleResponse);
}
function getActiveContainerYards() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/ContainerYards`, requestOptions).then(handleResponse);
}